import React from "react";
import { FlatList } from "react-native";
import { useRouter } from "expo-router";

import { EventCard } from "./Components/EventCard";
import NoEvents from "./Components/NoEvents";
import { useEvents } from "./Hooks/useEvents";

import ScreenLoadingIcon from "@/Components/Icons/Loading/ScreenLoadingIcon";
import ScreenLayout from "@/Components/Layouts/Native/ScreenLayout";
import { useHeaderContext } from "@/context/header/useHeaderContext";
import { type EventOverview } from "@/schemas/events/EventOverview";
import { InitialContentEventScreen } from "@/schemas/header/screens";

function EventsTab(): React.JSX.Element {
  const router = useRouter();
  const { currentScreen, setCurrentScreen } = useHeaderContext();
  const { events, isLoading } = useEvents(currentScreen);

  const clearFilters = (): void => {
    setCurrentScreen(InitialContentEventScreen);
  };

  const handleEventPress = (event: EventOverview): void => {
    router.push({
      params: { eventId: event.id },
      pathname: "/(main)/events/details",
    });
  };

  return isLoading ? (
    <ScreenLoadingIcon />
  ) : events.length === 0 ? (
    <NoEvents clearFilters={clearFilters} />
  ) : (
    <ScreenLayout isLoading={false}>
      <FlatList
        data={events}
        numColumns={1}
        keyExtractor={(item) => item.id}
        renderItem={({ item }) => (
          <EventCard event={item} onPress={() => handleEventPress(item)} />
        )}
      />
    </ScreenLayout>
  );
}

export default EventsTab;
